
import { Layout, Image } from 'antd';
const { Footer } = Layout;

const AdminFooter = ()=>{
    return(
        <Footer style={{ textAlign: 'center' }}>
            <Image 
            width={100}
            src="https://i.ibb.co/sFQXZKW/IT-Crowd.png" 
            alt='IT Logo'></Image>
            </Footer>
    )
}
export default AdminFooter